import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { name: "form" }
const _hoisted_4 = { class: "contain row" }
const _hoisted_5 = {
  key: 1,
  class: "page-container card col-md-8"
}
const _hoisted_6 = {
  key: 0,
  class: "row"
}
const _hoisted_7 = { class: "col-md-12 p-4" }
const _hoisted_8 = { class: "row mb-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3 required" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Code:")
], -1)
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { class: "row mb-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Type:")
], -1)
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = { class: "row mb-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3 required" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Description:")
], -1)
const _hoisted_16 = { class: "col-md-6" }
const _hoisted_17 = {
  key: 0,
  class: "row mb-3"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3 required" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Status:")
], -1)
const _hoisted_19 = { class: "col-md-6" }
const _hoisted_20 = { class: "row mb-3" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, null, -1)
const _hoisted_22 = { class: "d-flex col-md-6" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "p-1" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheHeader = _resolveComponent("TheHeader")!
  const _component_TheSidebar = _resolveComponent("TheSidebar")!
  const _component_ThePageLoading = _resolveComponent("ThePageLoading")!
  const _component_ThePageHeader = _resolveComponent("ThePageHeader")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_TheLoading = _resolveComponent("TheLoading")!
  const _component_ThePageError = _resolveComponent("ThePageError")!
  const _component_TheFooter = _resolveComponent("TheFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TheHeader),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_TheSidebar),
            (_ctx.isPageLoading)
              ? (_openBlock(), _createBlock(_component_ThePageLoading, { key: 0 }))
              : _createCommentVNode("", true),
            (!_ctx.isPageLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_ThePageHeader, {
                    onDeleteEvent: _ctx.deleteAccount,
                    renderDelete: (_ctx.identifier != null ? true : false),
                    isDeleting: _ctx.isDeleting
                  }, null, 8, ["onDeleteEvent", "renderDelete", "isDeleting"]),
                  (_ctx.pageError == '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, [
                            _hoisted_9,
                            _createElementVNode("div", _hoisted_10, [
                              _createVNode(_component_InputText, {
                                class: "p-inputtext",
                                type: "text",
                                maxlength: "10",
                                placeholder: "Code",
                                modelValue: _ctx.account.code,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.account.code) = $event))
                              }, null, 8, ["modelValue"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_11, [
                            _hoisted_12,
                            _createElementVNode("div", _hoisted_13, [
                              _createVNode(_component_InputText, {
                                class: "p-inputtext",
                                type: "text",
                                maxlength: "100",
                                placeholder: "Type",
                                modelValue: _ctx.account.type,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.account.type) = $event))
                              }, null, 8, ["modelValue"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_14, [
                            _hoisted_15,
                            _createElementVNode("div", _hoisted_16, [
                              _createVNode(_component_Textarea, {
                                class: "p-inputtext",
                                type: "text",
                                rows: "5",
                                cols: "30",
                                maxlength: "255",
                                placeholder: "Description",
                                modelValue: _ctx.account.description,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.account.description) = $event))
                              }, null, 8, ["modelValue"])
                            ])
                          ]),
                          (_ctx.identifier != null)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                _hoisted_18,
                                _createElementVNode("div", _hoisted_19, [
                                  _createVNode(_component_Dropdown, {
                                    options: _ctx.getActiveStatuses(_ctx.statuses),
                                    optionLabel: "name",
                                    optionValue: "value",
                                    placeholder: "-- Please Select --",
                                    modelValue: _ctx.account.isClosed,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.account.isClosed) = $event))
                                  }, null, 8, ["options", "modelValue"])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_20, [
                            _hoisted_21,
                            _createElementVNode("div", _hoisted_22, [
                              _createVNode(_component_Button, {
                                class: "p-button-sm",
                                disabled: _ctx.v$.account.$invalid || _ctx.isLoading,
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.identifier == null ? _ctx.save() : _ctx.update())),
                                label: "Save"
                              }, null, 8, ["disabled"]),
                              _hoisted_23,
                              _createVNode(_component_Button, {
                                class: "p-button-sm p-button-secondary",
                                onClick: _ctx.cancel,
                                label: "Cancel"
                              }, null, 8, ["onClick"]),
                              (_ctx.isLoading)
                                ? (_openBlock(), _createBlock(_component_TheLoading, { key: 0 }))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.pageError != '')
                    ? (_openBlock(), _createBlock(_component_ThePageError, {
                        key: 1,
                        onBackEvent: _ctx.cancel,
                        pageError: _ctx.pageError
                      }, null, 8, ["onBackEvent", "pageError"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_TheFooter)
          ])
        ])
      ])
    ])
  ], 64))
}